<app-popover-button [disabled]="disabled" color="warn" icon="delete_outline" type="icon">
  <div style="text-align: center">
    <p>
      <ng-content></ng-content>
    </p>
    <button app-popover-close color="warn" mat-button>
      {{ 'COMMON.no' | translate }}
    </button>

    <button (click)="action.emit()"
            app-popover-close
            color="primary"
            mat-button
            [matTooltip]="'QUERY_BUILDER.delete' | translate">
      {{ 'COMMON.yes' | translate }}
    </button>
  </div>
</app-popover-button>
